import React, {useEffect, useState} from 'react';
import {Button, Container, Flex, Space, Title, TextInput, useMantineTheme} from '@mantine/core';

import TableFolders from "../../components/TableFolders";
import {IconFileUpload} from "@tabler/icons-react";
import { IconSearch } from "@tabler/icons-react";
import {ArticleColumns, ImageColumns, ImageRow} from "../../interfaces/ImageTablePage";
import {useLazyGetAllImageFoldersQuery, useUploadImageFoldersMutation} from "../../services/ArticleService";
import ShellLayout from "../../components/layoutComponents/shellLayout/ShellLayout";
import ConnectionStatus from "../../components/layoutComponents/connectionStatus/ConnectionStatus";
import classes from "../../components/pageComponents/articoli/tableArticles/TableArticles.module.css";

const CaricamentoImmagini = () =>  {

    const [search, setSearch] = useState<string>("");

    const theme = useMantineTheme();
    const [getAllImageFolders, isLoadingGetAllImageFolders, isErrorGetAllImageFolders] = useLazyGetAllImageFoldersQuery();
    const [uploadFolder, isLoading] = useUploadImageFoldersMutation();

    const [folders, setFolders] = useState<ImageRow[]>([])
    const [selectedFolders, setSelectedFolders] = useState<ImageRow[]>([]);


    useEffect(() => {
        getAllImageFolders().then((r) => {
            if(r.data == undefined) {
            }
            else {
                let mappedData: ImageRow[] = []
                r.data.forEach(d => mappedData.push({...d}))
                setFolders(mappedData)
            }

        })
    }, [])

    const handleClick = () => {
        if(selectedFolders.length === 0) {
            return
        }


        selectedFolders.forEach(folder => {
            folder.loading = {loading: true, completed: undefined, error: undefined}
            let i = folders.findIndex(f => f.name === folder.name)
            folders[i] = folder
        })
        setFolders([...folders])

        selectedFolders.forEach(folder => {
            uploadFolder({folders: [folder.name]})
                .unwrap()
                .then(resp => {
                    folder.loading = {loading: undefined, completed: true, error: undefined}
                    let i = folders.findIndex(f => f.name === folder.name)
                    folders[i] = folder
                    setFolders([...folders])
                })
                .catch(err => {
                    folder.loading = {loading: undefined, completed: undefined, error: true}
                    let i = folders.findIndex(f => f.name === folder.name)
                    folders[i] = folder
                    setFolders([...folders])
                })
        })
    }

    return (
        <ShellLayout
            Body={
                <>
                    <Space h={'lg'}></Space>
                    <Container size={'95%'}>
                        <Flex justify={'space-between'}>
                            <Title order={1} fw={500} c={theme.colors.textBlack[0]} mb={'xl'}>Immagini</Title>
                            <ConnectionStatus />
                        </Flex>
                        <Flex style={{paddingBottom: '32px', paddingTop: '16px'}} gap={"sm"} wrap="wrap">
                            <Button
                                radius={'lg'}
                                leftSection={<IconFileUpload/>}
                                onClick={handleClick}
                                style={{backgroundColor: theme.colors.green[2], color: 'black', '&:hover': {backgroundColor: theme.colors.green[3]}}}>
                                Carica Immagini
                            </Button>
                            <TextInput
                                placeholder="Cerca cartella"
                                value={search}
                                onChange={(e) => setSearch(e.currentTarget.value)}
                                radius="lg"
                                leftSection={<IconSearch size={16} />}
                                classNames={{
                                    root: classes.searchInputTextRoot,
                                    input: classes.searchInputTextInput,
                                    wrapper: classes.searchInputTextWrapper
                                }}
                                style={{flexBasis: '60%'}}
                            />
                        </Flex>
                        <TableFolders
                            columns={ImageColumns}
                            rows={folders}
                            loading={isLoadingGetAllImageFolders.isFetching}
                            selected={selectedFolders}
                            setSelected={setSelectedFolders}
                            externalSearch={search} />
                    </Container>

                </>

            }
        />
    )
}

export default CaricamentoImmagini;